module.exports = __webpack_public_path__ + "static/img/no1.8bc91565.png";